import { createStore } from 'vuex'

import user from './modules/user';
import toast from './modules/toast';
import listener from './modules/listener';
import registration from './modules/registration';
import permissions from './modules/permissions';
import roles from './modules/roles';

/**
 * Store global data here.
 * 
 * https://vuex.vuejs.org/guide/
 */
const store = createStore({
	modules: { user, toast, listener, registration, permissions, roles }
});

export default store;
